import { CURRICULUM_MODULE_STORE_KEY } from '../constants';
import type { State as CurriculumModulesState } from '../reducers/curriculumModule';

export default (state: GlobalState) => state[CURRICULUM_MODULE_STORE_KEY] as CurriculumModulesState;
